import React, { createContext, useState, useEffect } from "react";
import { getSystemInfo } from "../services/system.service";

export const SystemContext = createContext();
    
export const SystemProvider = ({children}) => {
    const [systemInfo, setSystemInfo] = useState(null);

    useEffect(() => {
        const fn = async () => {
            const systemData = await getSystemInfo();
            switch(systemData.env) {
                case "uat":
                    systemData.fqdn = "wwwqa.vodacom.co.za";
                    break;
                case "prd":
                    systemData.fqdn = "www.vodacom.co.za";
                    break;
                default:
                    systemData.fqdn = "localhost:3000";
                    break;
            }
            systemData.dashboard_link = `${systemData.proto}://${systemData.fqdn}/fibre/prepaid?login=true`;
            setSystemInfo(systemData);
        }
        fn();
    }, [])

    return (
        <SystemContext.Provider value={systemInfo}>
            {children}
        </SystemContext.Provider> 
    );
};
